import React from 'react';
import {AccountType} from '../../components/constants/securspace-constants';
import {Grid} from '@mui/material';
import SignUpForm from '../../components/SignUpForm';
import InfoColumn from './InfoColumn';
import PropTypes from 'prop-types';
import {styled} from "@mui/material/styles";

const MainContainer = styled(Grid)(() => ({
    position: 'relative',
    padding: '1em',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
}));

// Negative translateY pulls content up over the hero banner (ss-signup-container, 28.57em tall)
const WrapperContainer = styled(Grid)(({theme}) => ({
    width: '100%',
    maxWidth: '93em',
    transform: 'translateY(-20em)',
    [theme.breakpoints.down('md')]: {
        transform: 'translateY(-18em)',
    },
}));

const SignUp = (props) => {
    const type = props.type || AccountType.BUYER;

    return (
        <section>
            <div className="ss-signup-container" />
            <MainContainer container justifyContent='center' alignContent='center'>
                <WrapperContainer
                    container
                    justifyContent='center'
                    alignItems='flex-start'
                    rowSpacing={3}
                    columnSpacing={{xs: 0, md: 5}}
                >
                    <Grid item xs={12} md={6}>
                        <SignUpForm
                            type={type}
                            handleAccountChange={props.handleAccountChange}
                            socialLoginTemporaryUser={props.socialLoginTemporaryUser}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InfoColumn accountType={type} />
                    </Grid>
                </WrapperContainer>
            </MainContainer>
        </section>
    );
};

SignUp.propTypes = {
    type: PropTypes.oneOf([AccountType.BUYER, AccountType.SUPPLIER]),
};

export default SignUp;
